module.exports = __webpack_public_path__ + "img/brand_5.4f49128c.png";